import type { TFunction } from 'i18next';

import { formatDate } from '@/shared/utils/date';
import { cn } from '@/shared/utils/cn';

import { continuationNoteKey, truncateAdminId } from '../lib/pendingPaymentContinuation';

export interface PendingPaymentContinuationNoteProps {
  resolution?: string;
  continuedAtIso?: string;
  continuedBy?: string;
  t: TFunction<'orders'>;
  className?: string;
}

export function PendingPaymentContinuationNote({
  resolution,
  continuedAtIso,
  continuedBy,
  t,
  className,
}: PendingPaymentContinuationNoteProps) {
  const noteKey = continuationNoteKey(resolution ?? '');
  if (!noteKey) return null;

  const when = continuedAtIso?.trim() ? formatDate(continuedAtIso, 'dateTime') : '';
  const adminId = continuedBy?.trim() ?? '';

  return (
    <div className={cn('text-xs text-fg-muted', className)}>
      <p>
        <span className="font-medium text-fg">{t(noteKey)}</span>
        {when ? <span>{` · ${when}`}</span> : null}
      </p>
      {adminId ? (
        <p className="mt-0.5 font-mono text-[11px]" title={adminId}>
          {truncateAdminId(adminId)}
        </p>
      ) : null}
    </div>
  );
}
